import React from 'react';
import MessageCreatorComponent from '../components/message_creator';
import MessageCreatorActions from '../actions/message_creator';

const MessageCreatorContainer = props => {
  const { conversationId } = props;

  return (
    <MessageCreatorComponent
      { ...props }
      url={ '/conversations/' + conversationId + '/messages' }
      persistMessage={ MessageCreatorActions.persist } />
  );
}

export default MessageCreatorContainer;
